import moment from 'moment';

function getCookieValue(name) {
    const b = document.cookie.match(`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`);
    return b ? decodeURIComponent(b.pop()) : '';
}

function deleteCookie(name) {
    const expires = new Date().toUTCString();
    const path = '/';
    const cookie = `${name}=; expires=${expires}; path=${path}; domain=.paytmmoney.com`;
    const cookieOnCurrentDomain = `${name}=; expires=${expires}; path=${path};`;
    document.cookie = cookie;
    document.cookie = cookieOnCurrentDomain;
}

function getUrlParameter(name, queryString) {
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(queryString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const isBrowser = () => typeof window !== 'undefined';

function getDateDifference(startMoment, endDate, dateFormat) {
    if (!endDate) {
      return 0;
    }
    const endMoment = typeof endDate === 'number' ? moment(endDate) : moment(endDate, dateFormat);
    return endMoment.isValid() ? startMoment.diff(endMoment) : 0;
}

const formatDateTimeString = (date, inputDtFormat, outputDtFormat) => {
    // const isValidDate = moment(date, inputDtFormat, true).isValid(); // use for strict format mode
    const isValidDate = moment(date, inputDtFormat).isValid();
    if (isValidDate) {
      return moment(date, inputDtFormat).format(outputDtFormat);
    }
    return null;
};

function isValidNumber(value) {
  if (!value) return false;
  if (Number.isNaN(value) || value === Infinity) {
    return false;
  }
  return true;
}

function roundValue(value, decimals = 2, roundOffToLowerInt = false) {
    if (!isValidNumber(value)) {
        return '0.00';
    }
    const base = 10 ** decimals;
    const mathFn = roundOffToLowerInt ? Math.floor : Math.round;
    return (mathFn(value * base) / base).toFixed(decimals);
}

export {
    getCookieValue,
    deleteCookie,
    isBrowser,
    getUrlParameter,
    getDateDifference,
    formatDateTimeString,
    roundValue,
};